export const REKOMENDATELNYH_TEHNOLOGIY_PATH = '/legal/pravila-primeneniya-rekomendatelnyh-tehnologiy/';
export const SHOP_PATH = '/shop/';
export const DEFAULT_SEARCH_PATH = '/search/';
